export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();


      console.log(config)

      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.headers['Accept'] = 'application/json';

      if (authToken) {
        // config.headers.Authorization = `Bearer ${authToken}`;
        config.headers['x-auth-token'] = `${authToken}`;
      }

      return config;
    }, 
    err => Promise.reject(err)
  );
} 
